import React from 'react';

const PageNotFound = props => {
  return (
    <div className="page-not-found">We're sorry. This page doesn't exist!</div>
  );
};

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/preference/components/PageNotFound/index.js